import "../../../resources/less/Family/ThemePages/BaseThemePage.less";
export default class BaseThematique {
  constructor() {
    $(".js-close-on-click").on("click", () => {
      window.close();
    });
  }
}
